
import _ from 'lodash'
import { Component } from 'react'

import { toFHIR, fromFHIR } from '../../../../../../lib/Proxy/attorney'
import CrudTable from '../../../../../shared/CrudTable'
import ConfirmationDeleteDialog from '../../../../../shared/DeleteDialog/ConfirmationDeleteDialog'
import FormattedPhone from '../../../../../shared/Phone/FormattedPhone'

import AttorneyForm from './form'

const tableDefinition = [
  {
    title: 'First Name',
    displayFn: v => _.capitalize(v.firstName)
  },
  {
    title: 'Last Name',
    displayFn: v => _.capitalize(v.lastName)
  },
  {
    title: 'Firm',
    displayFn: v => _.capitalize(v.firm)
  },
  {
    title: 'Phone',
    displayFn: v => <FormattedPhone number={v.phone} />
  },
  {
    title: 'Email',
    displayFn: v => v.email
  }
]

class AttorneyGrid extends Component {
  constructor (props) {
    super(props)

    const patientId = this.props.params.id

    this.urls = {
      get: () =>
        `/v2/patients/${patientId}/supportNetwork?relationship=attorney`,
      create: () => `/patients/${patientId}/fhir/RelatedPerson`,
      update: entry =>
        `/patients/${patientId}/fhir/RelatedPerson/${entry.id}`,
      delete: entry =>
        `/patients/${patientId}/fhir/RelatedPerson/${entry.id}`
    }

    this.mapFns = {
      toForm: fromFHIR,
      toFhir: entry => toFHIR(entry, patientId)
    }
  }

  /* queueIssues(data) {
   *   const { dispatch } = this.props;
   *   const iq = newEntry IssueQueuer(Choices, dispatch, data.attorneys[data.attorneyIndex], data.attorneys);
   *   iq.queueIssues();
   * }
   */
  render () {
    const patientId = this.props.params.id
    return (
      <div className='main'>
        <h2>Attorneys</h2>

        <div className='row'>
          <div
            className='col-xs-12'
            style={{ padding: '0px' }}
          >
            <CrudTable
              entryType='attorney'
              entrySet={patientId}
              tableDefinition={tableDefinition}
              urlFns={this.urls}
              mapFns={this.mapFns}
              form={AttorneyForm}
              deleteDialog={ConfirmationDeleteDialog}
              additionalDeleteDialogProps={{ prompt: 'Really delete?' }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default AttorneyGrid
